import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withRouter } from "react-router-dom";

import NewNavigationDropdownItem from "./NewNavigationDropdownItem";
import NoStyleButton from "components/Library/NoStyleButton";
import DropdownWrapper from "../DropdownWrapper";
import SocialLinks from "../SocialLinks";
import Icon from "components/Library/Icon";
import SearchWindow from "./SearchWindow";

import styles from "./NewNavigation.css";
import LatestStories from "./LatestStories";

export class NewNavigationDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: true,
    };
    this.closeButtonElement = React.createRef();
    this.lastMenuItemElement = React.createRef();
    this.lastLatestStoriesItemElement = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("keydown", this.focusLoop);
  }

  focusLoop = e => {
    //If forward navigating tab past final Item, shift focus to closeButton.
    if (
      e.target.className.indexOf("searchSubmit") !== -1 ||
      e.target.className.indexOf("finalLatestStoriesItem") !== -1
    ) {
      if (e.key === "Tab" && !e.shiftKey) {
        e.preventDefault();
        if (this.closeButtonElement) {
          this.closeButtonElement.current.focus();
        }
      }
    }

    //If backward navigating from closeButton, shift focus to last dropdown item.
    if (e.target.parentElement.className.indexOf("mobileExitSpan") !== -1) {
      if (e.key === "Tab" && e.shiftKey) {
        e.preventDefault();
        if (this.props.isOpen && this.lastMenuItemElement) {
          this.lastMenuItemElement.current.focus();
        } else if (
          this.props.isLatestOpen &&
          this.lastLatestStoriesItemElement
        ) {
          this.lastLatestStoriesItemElement.current.focus();
        }
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener("keydown", this.focusLoop);
  }

  getNewsletterItems() {
    return [
      {
        name: "Sign up for Axios AM",
        url: "https://link.axios.com/join/am-signup?utm_source=site_navbar",
      },
      { name: "All newsletters", url: "/newsletters", internal: true },
    ];
  }

  getMoreItems() {
    return [
      { name: "About", url: "/about", internal: true },
      { name: "Events", url: "/events", internal: true },
      { name: "Contact newsroom", url: "mailto:news@axios.com" },
      { name: "Privacy & terms", url: "/legal", internal: true },
      { name: "Advertise with us", url: "mailto:ads@axios.com" },
    ];
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      document
        .querySelectorAll('[data-content-id="DropdownWrapper"]')
        .forEach(el => {
          el.scrollTo(0, 0);
        });
    }
  }

  render() {
    return (
      <div id="main-menu" role="menu" className={styles.dropdown}>
        <ul className={styles.dropdownUL}>
          <DropdownWrapper
            contentId={"DropdownWrapper"}
            open={this.props.isOpen}
          >
            <span className={styles.mobileExitSpan}>
              <NoStyleButton
                onClick={this.props.toggle ? this.props.toggle : () => {}}
                buttonRef={this.closeButtonElement}
                ariaLabel="Exit mobile navigation menu"
              >
                <Icon
                  name="close-nav"
                  className={classNames(styles.exitIcon)}
                />
              </NoStyleButton>
            </span>
            <NewNavigationDropdownItem
              name="Newsletters"
              isMobile={this.state.isMobile}
              mobileToggle={this.props.toggle}
              items={this.getNewsletterItems()}
              className="gtm-menu-dropdown"
            />
            <NewNavigationDropdownItem
              name="Sections"
              isMobile={this.state.isMobile}
              mobileToggle={this.props.toggle}
              items={this.props.results.sections}
              className="gtm-menu-dropdown"
            />
            <NewNavigationDropdownItem
              name="Special Features"
              isMobile={this.state.isMobile}
              mobileToggle={this.props.toggle}
              items={this.props.results.specialFeatures || []}
              className="gtm-menu-dropdown"
            />
            <NewNavigationDropdownItem
              name="More"
              isMobile={this.state.isMobile}
              mobileToggle={this.props.toggle}
              items={this.getMoreItems()}
              className="gtm-menu-dropdown"
            />

            <SocialLinks className={styles.socialList} />

            <a href="/about" className={styles.mobileSectionHeader}>
              About Us
            </a>

            <span className={styles.mobileSearchSpan}>
              <SearchWindow searchRef={this.lastMenuItemElement} />
            </span>
          </DropdownWrapper>

          <DropdownWrapper
            contentId={"DropdownWrapper"}
            open={this.props.isLatestOpen}
          >
            <span className={styles.mobileExitSpan}>
              <NoStyleButton
                onClick={this.props.toggle ? this.props.toggle : () => {}}
                buttonRef={this.closeButtonElement}
                ariaLabel="Exit mobile navigation menu"
              >
                <Icon
                  name="close-nav"
                  className={classNames(styles.exitIcon)}
                />
              </NoStyleButton>
            </span>
            <div role="complementary">
              <LatestStories
                latestStoriesRef={this.lastLatestStoriesItemElement}
              />
            </div>
          </DropdownWrapper>
        </ul>
      </div>
    );
  }
}

NewNavigationDropdown.proptypes = {
  isOpen: PropTypes.bool.isRequired,
  isLatestOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
  results: PropTypes.array,
};

export default withRouter(NewNavigationDropdown);
